import {createRouter, createWebHistory} from 'vue-router';
import axios from 'axios';

import LayoutNone from "../layout/LayoutNone.vue";
import LayoutDefault from "../layout/LayoutDefault.vue";

const router = new createRouter({
  history : createWebHistory(),
  props: true,
  routes: [
    {
      path: '/',
      name: 'Login',
      meta: {
        layout: LayoutNone,
        title: '로그인',
        footerType: 'full',
        authRequired: false,
      },
      component: () => import("../views/login/Login.vue"),
      beforeEnter(routeTo, routeFrom, next) {
        localStorage.clear();
        next();
      },
    },
    // 홈마트 메인
    {
      path: '/Main',
      name: 'Main',
      meta: {
        layout: LayoutNone,
        title: '메인',
        authRequired: true,
      },
      component: () => import("../views/main/main.vue")
    },
    // 홈마트 할인쿠폰
    {
      path: '/Coupon',
      name: 'coupon',
      meta: {
        layout: LayoutDefault,
        title: '모바일 쿠폰',
        footerType: 'default',
        authRequired: true,
      },
      component: () => import("../views/mart/martCoupon.vue")
    },
    // 홈마트 할인쿠폰 상세
    {
      path: '/CouponDetail',
      name: 'couponDetail',
      meta: {
        layout: LayoutDefault,
        title: '모바일 쿠폰 상세',
        footerType: 'default',
        authRequired: true,
      },
      component: () => import("../views/mart/martCouponDetail.vue")
    },
    // 홈마트 포인트
    {
      path: '/Point',
      name: 'point',
      meta: {
        layout: LayoutDefault,
        title: '포인트',
        footerType: 'default',
        authRequired: true,
      },
      component: () => import("../views/mart/martPoint.vue")
    },
    // 홈마트 영수증
    {
      path: '/Receipt',
      name: 'martReceipt',
      meta: {
        layout: LayoutDefault,
        title: '전자영수증',
        footerType: 'default',
        authRequired: true,
      },
      component: () => import("../views/mart/martReceipt.vue")
    },
    {
      path: '/receiptInfo',
      name: 'martReceiptDetail',
      meta: {
        layout: LayoutDefault,
        title: '영수증',
        footerType: 'default',
        authRequired: false,
      },
      component: () => import("../views/mart/martReceiptDetail.vue")
    },
    {
      path: '/rec/:cno',
      name: 'login',
      meta: {
        layout: LayoutNone,
        title: '메인',
        footerType: 'full',
        authRequired: false,
      },
      component: () => import("../views/main/main.vue")
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y:0}
  },
});

router.beforeEach(async(to, from, next) => {

  const authRequired = to.matched.some((route) => route.meta.authRequired)

  if(to.fullPath == '/'){
    next();
  } else {
    if (!authRequired) {
      if( to.query.hasOwnProperty("rno") || to.path.split("/")[1] == "rec" ) {
        if( to.path.split("/")[1] == "rec" && to.params.cno != undefined ) {
          await axios.post('/v1/user/autoLogin', {
            headers: {"Content-Type": 'application/json'},
            'coupon_no': to.params.cno
          }).then(response => {
            if( response.data.result_code == '0000' && response.data.user_list.length == 1 ) {
              localStorage.setItem('userInfo', JSON.stringify(response.data.user_list[0]));
              localStorage.setItem('userToken', JSON.stringify(response.data.token));
              return next();

            } else {
              return next({name: 'Login'});
            }
          });
        } else {
          return next();
        }
      } else {
        return next({name: 'Login'});
      }
    } else {

      const userInfo = JSON.parse(localStorage.getItem('userInfo'));

      if (userInfo == null) {
        return next({name: 'Login', query: {redirectFrom: to.fullPath}})
      } else {

        let params = {};
        params.user_no = userInfo.user_no

        await axios.post('/v1/user/tokenConfirm', params, {
          headers: {
            "X-AUTH-TOKEN": JSON.parse(localStorage.getItem('userToken'))
          }
        }).then(response => {

          if (response.data.result_code == '0000') {
            next();
          } else {
            localStorage.clear();
            next({name: 'Login', query: {redirectFrom: to.fullPath}})
          }
        }).catch(() => {
          localStorage.clear();
          next({name: 'Login', query: {redirectFrom: to.fullPath}})
        });

      }
    }
  }

});

export default router